/**
 * @desc 查询商城首页横幅
 */
import { BannerEntity, BannerParam } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBannerListParameter = BannerParam

const method = 'GET'
const url = '/content/mall/banner/list'

export const queryBannerListApi = (
  params?: QueryBannerListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<BannerEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryBannerListApi.method = method
queryBannerListApi.url = url
